import { render, staticRenderFns } from "./ShippingProfileSelect.vue?vue&type=template&id=5002ca00&"
import script from "./ShippingProfileSelect.vue?vue&type=script&lang=js&"
export * from "./ShippingProfileSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/DIA-3dprima_v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5002ca00')) {
      api.createRecord('5002ca00', component.options)
    } else {
      api.reload('5002ca00', component.options)
    }
    module.hot.accept("./ShippingProfileSelect.vue?vue&type=template&id=5002ca00&", function () {
      api.rerender('5002ca00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/checkout/ShippingProfileSelect.vue"
export default component.exports